import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "14", y1: "2", y2: "2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "12", x2: "15", y1: "14", y2: "11", stroke: `${color}` }),
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "14", r: "8", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Timer";
const Timer = memo(themed(Icon));
export {
  Timer
};
//# sourceMappingURL=timer.js.map
